import { useOutletContext } from "react-router-dom";

import DigikalaSettingForm from "../components/digikalaOrders/DigikalaSettingForm";

export default function DigikalaSellerInformation() {
  const data = useOutletContext();
  return (
    <div>
      <DigikalaSettingForm getSellerData={data} />
    </div>
  );
}
